import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ContractService } from '../../_services';
import { ContractBase } from "./contract.base";

@Component({
	selector: 'contract-rent-charges',
	template: require('./contract-rent-charges.template.html'),
	encapsulation: ViewEncapsulation.None
})
export class ContractRentChargesComponent extends ContractBase implements OnInit {

	get rentAndCharges(): any {
		const contract: any = this.contract;
		return contract != null ? contract.rentAndCharges : null;
	}

	get contractIfrs(): any {
		const contract: any = this.contract;
		return contract != null ? contract.ifrs : null;
	}

	constructor(
		protected readonly contractService: ContractService) {
		super(contractService);
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

	yesNoOptions = [{ id: false, name: 'No' }, { id: true, name: 'Yes' }];

	get rentFreeValue(): number {
		if (this.rentAndCharges &&
			this.rentAndCharges.yearlyRent &&
			this.rentAndCharges.yearlyRent !== 0 &&
			this.rentAndCharges.rentFreePeriod &&
			this.rentAndCharges.rentFreePeriod !== 0) {
			return (this.rentAndCharges.yearlyRent / 12) * this.rentAndCharges.rentFreePeriod;
		}

		return null;
	}


	updateMargetingCost(contract, event) {
		let newMarketingCost = event.newValue * this.rentAndCharges.yearlyRent;
		event.newValue = newMarketingCost;
		event.id = "rentAndCharges.marketingCost";
		this.onChange(contract, event);
	}

	updateCommonCharges(contract, event) {
		let newCommonCharges = event.newValue * this.rentAndCharges.yearlyRent;
		event.newValue = newCommonCharges;
		event.id = "rentAndCharges.commonCharges";
		this.onChange(contract, event);
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-rent-charges.component.ts